import { Link } from "@/i18n/navigation";


export default function DistrictList({ item }) {
  if (!item) return null;

  // Name (location-pages için) veya DisplayName (category-pages için) kullan
  const name = item.DisplayName || item.Name || "";
  return (
    <Link
      href={item.RedirectUrl || "#"}
      className="text-foreground text-base lg:text-lg font-medium hover:text-primary transition-colors cursor-pointer"
    >
      {name}
    </Link>
  );
}
